import React from 'react';
import '../css/skeleton.css';
import '../css/normalize.css';
import '../css/components.css';
import { motion } from 'framer-motion';

function Card(props) {
  const indexStr = String(props.i + 1).padStart(2, '0');

  const variants = {
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.08,
        duration: 0.4,
        ease: [0.25, 1, 0.5, 1],
      },
    }),
    hidden: { opacity: 0, y: 24 },
  };

  return (
    <a href={props.link} target="_blank" rel="noopener noreferrer" className="card-anchor">
      <motion.div
        className="Card industrial-card"
        initial="hidden"
        animate="visible"
        custom={props.i}
        variants={variants}
        whileHover={{ y: -4 }}
      >
        {/* Corner Registration Ticks */}
        <div className="corner-tick top-left">+</div>
        <div className="corner-tick top-right">+</div>
        <div className="corner-tick bottom-left">+</div>
        <div className="corner-tick bottom-right">+</div>

        <div className="card-top-bar">
          <span className="card-index-tag">REF // {indexStr}</span>
          <span className="card-action-icon">[ ↗ ]</span>
        </div>

        <div className="cover-wrapper">
          <img className="cover" src={props.cover} alt={props.title} />
        </div>

        <div className="data">
          <h2>
            {props.title}
            <span className="accent-period">.</span>
          </h2>
          <p>{props.subtitle}</p>
        </div>
      </motion.div>
    </a>
  );
}

export default Card;